import React from 'react';

// components
import { CustomCircleIcon } from '@zola/zola-ui/src/components/CircleIcon/CircleIcon';
import { CheckmarkIcon } from '@zola/zola-ui/src/components/SvgIcons/Checkmark';

// assets
import PriceTag from '@zola/zola-ui/src/assets/images/iconsRebrand/price_tag.svg';
import Website from '@zola/zola-ui/src/assets/images/iconsRebrand/website.svg';
import Registry from '@zola/zola-ui/src/assets/images/iconsRebrand/registry.svg';

// styles
import COLORS3 from '@zola/zola-ui/src/styles/emotion/colors3';
import { Hed, IconContainer, IconListContainer, StyledItems } from './WebsitePdpValueProps.styles';

export type WebsitePdpValuePropsProps = {
  className?: string;
};

const WebsitePdpValueProps: React.FC<WebsitePdpValuePropsProps> = ({ className }) => (
  <div className={className} data-testid="WebsitePdpValueProps">
    <IconListContainer>
      <IconContainer>
        <CustomCircleIcon image={PriceTag} bgColor={COLORS3.CLOUD_100} />
        <p data-testid="WebsitePdpValueProps__Callout1">
          Free From Start
          <br />
          to Finish
        </p>
      </IconContainer>
      <IconContainer>
        <CustomCircleIcon image={Website} bgColor={COLORS3.CLOUD_100} />
        <p data-testid="WebsitePdpValueProps__Callout2">
          Custom Website
          <br />
          Address
        </p>
      </IconContainer>
      <IconContainer>
        <CustomCircleIcon image={Registry} bgColor={COLORS3.CLOUD_100} />
        <p data-testid="WebsitePdpValueProps__Callout3">
          Integrated
          <br />
          Registry
        </p>
      </IconContainer>
    </IconListContainer>
    <div>
      <Hed>With A Zola Wedding Website, you can:</Hed>
      <ul>
        <StyledItems>
          <CheckmarkIcon />
          <span>Password protect your website.</span>
        </StyledItems>
        <StyledItems>
          <CheckmarkIcon />
          <span>Purchase a custom website domain name through Zola.</span>
        </StyledItems>
        <StyledItems>
          <CheckmarkIcon />
          <span>Integrate your Zola registry or link to one from another store.</span>
        </StyledItems>
        <StyledItems>
          <CheckmarkIcon />
          <span>
            Collect RSVPs, ask for meal preferences, and customize other questions for guests
          </span>
        </StyledItems>
        <StyledItems>
          <CheckmarkIcon />
          <span>
            Edit, hide, or reorder pages, including: Home, Schedule, Travel, Registry, Wedding
            Party, Photos, Things To Do, FAQs, and RSVPs.
          </span>
        </StyledItems>
      </ul>
    </div>
  </div>
);

export default WebsitePdpValueProps;
